/*
 * Copyright (c) 2026. The content provided herein is protected by copyright law. Unauthorized use, reproduction, or distribution of this material without proper licensing, knowledge, and contract agreement from the author is strictly prohibited. Any infringement of these rights may result in legal action. For inquiries regarding the use of this content, please contact the author for proper authorization and agreement.
 */

import { z } from 'zod'
import { useTranslation } from 'react-i18next'
import { useMemo } from 'react'

export const useEmailTemplateSchema = () => {
    const { t } = useTranslation()

    return useMemo(() => z.object({
        id: z.number().optional(),
        model_id: z.number(),
        model_name: z.string(),
        name: z.string().min(1, t('Name is required')),
        subject: z.string().min(1, t('Subject is required')),
        content: z.string().min(1, t('Content is required')),
        category: z.string().optional(),
    }), [t])
}

export type EmailTemplateInputs = z.infer<ReturnType<typeof useEmailTemplateSchema>>
